module.exports = __webpack_public_path__ + "img/uk-events-2.809e90f3.png";